




























































































































import { get, sync } from 'vuex-pathify';
import { mapActions } from 'vuex';
import { FormRules } from '@/mixins/FormRules';

import Vue from 'vue';

// TODO: LF - 2020-03-14 - Need to have appropriate step name defined
// const enum STEP {
//   REQUEST_EMAIL = 1,
//   SENT_EMAIL = 2
// }

export default Vue.extend({
  name: 'PasswordReset',
  mixins: [FormRules],

  data: () => ({
    step: 1,
    email: ''
  }),

  computed: {
    authLoading: get('auth/getLoading'),
    getError: get('auth/getAuthError'),
    companyName: sync('app/companyName'),
    darkCompanyImage: sync('app/darkCompanyImage'),

    firstButton() {
      switch (this.step) {
        case 1:
          return 'Create Account';
        case 2:
          return 'Forgot Password';
        default:
          return 'Back';
      }
    },

    currentTitle() {
      switch (this.step) {
        case 1:
          return 'Sign-up';
        case 2:
          return 'Create a password';
        default:
          return 'Account created';
      }
    }
  },

  methods: {
    ...mapActions({
      forgotPassword: 'auth/forgotPassword',
      requestEmail: 'auth/requestEmail',

      // TODO: LF - 2020-03-14 - LeRon to confirm if clearError is needed
      clearError: 'error/clearError'
    }),

    back(): any {
      return this.step--;
    },

    next(): any {
      return this.step++;
    },

    SecondaryCardButton(): any {
      switch (this.step) {
        case 1:
          return this.$router.push({ name: 'sign-in' });
        default:
          return this.back();
      }
    },

    PrimaryCardButton(): any {
      switch (this.step) {
        case 1:
          return this.sendEmail(this.email);
        default:
          return 'Account created';
      }
    },

    async sendEmail(email: string) {
      await this.forgotPassword(email).then(() => this.next());
    }
  }
});
